/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_LabelInputs */

const tr_landing_pricing_included_label = /** @type {(inputs: Landing_Pricing_Included_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm planlar şunları içerir`)
};

const en_landing_pricing_included_label = /** @type {(inputs: Landing_Pricing_Included_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every plan includes`)
};

const de_landing_pricing_included_label = /** @type {(inputs: Landing_Pricing_Included_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In allen Plänen enthalten`)
};

const ru_landing_pricing_included_label = /** @type {(inputs: Landing_Pricing_Included_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все планы включают`)
};

/**
* | output |
* | --- |
* | "Every plan includes" |
*
* @param {Landing_Pricing_Included_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_label = /** @type {((inputs?: Landing_Pricing_Included_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_label(inputs)
	if (locale === "de") return de_landing_pricing_included_label(inputs)
	if (locale === "ru") return ru_landing_pricing_included_label(inputs)
	return tr_landing_pricing_included_label(inputs)
});